module.exports = __webpack_public_path__ + "static/img/014.4e47b44f.jpg";